<template>
    <div class="catalog-search-wrapper">
        <div class="catalog-search">
            <input
                :value="props.modelValue"
                class="catalog-search-input"
                placeholder="Enter design name"
                type="search"
                @input="onChange"
            />
            <i class="search-icon"></i>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { debounce } from 'remeda'

const props = defineProps<{ modelValue: string }>()
const emit = defineEmits(['update:modelValue'])

// eslint-disable-next-line deprecation/deprecation
const emitDebounced = debounce(
    (value: string) => {
        emit('update:modelValue', value)
    },
    { waitMs: 500 }
)

const onChange = (event: Event) => {
    const target = event.target as HTMLInputElement

    emitDebounced.call(target.value)
}
</script>

<style lang="scss" scoped>
.catalog-search-wrapper {
    width: 100%;
    display: flex;
    align-content: center;
    justify-content: center;
    margin: 20px 0 0 0;

    .catalog-search {
        width: 300px;
        height: 50px;
        background: $white;
        border-radius: 25px;
        border: 1px solid $grey-300;
        display: flex;

        .search-icon {
            width: 50px;
            height: 50px;
            display: block;
            flex-shrink: 0;
            position: relative;
            margin-right: 5px;

            &:before {
                content: '';
                width: 16px;
                height: 16px;
                display: block;
                border: 2px solid $grey-400;
                border-radius: 50%;
                position: absolute;
                top: 15px;
                left: 15px;
            }

            &:after {
                content: '';
                width: 3px;
                height: 6px;
                display: block;
                background: $grey-400;
                position: absolute;
                top: 29px;
                right: 18px;
                transform: rotate(-45deg);
            }
        }

        input {
            width: 100%;
            height: 20px;
            line-height: 20px;
            margin: 15px 0;
            padding: 0 0 0 20px;
        }
    }
}
</style>
